import Image from 'next/image'
import { ComponentPropsWithoutRef } from 'react'
import { cn } from '~shared/utils/cn'

interface AboutMitmSectionCardProps extends ComponentPropsWithoutRef<'li'> {
  title: string
  label: string
}

const AboutMitmSectionCard = (props: AboutMitmSectionCardProps) => {
  const { className = '', title, label, children, ...rest } = props

  return (
    <li
      className={cn(
        'relative flex flex-col justify-between rounded-[24px] p-4 lg:p-[24px] overflow-hidden',
        className
      )}
      {...rest}>
      {children}
      <p className='relative text-[30px] md:text-[50px] lg:text-[64px] leading-[1] tracking-[-0.04em]'>
        {title}
      </p>
      <p className='relative text-[14px] md:text-[16px] leading-[1.1]'>
        {label}
      </p>
    </li>
  )
}

export interface AboutMitmSectionProps
  extends ComponentPropsWithoutRef<'section'> {}

export const AboutMitmSection = (props: AboutMitmSectionProps) => {
  const { className = '', ...rest } = props

  return (
    <section className={cn('container container-slim', className)} {...rest}>
      <h2 className='text-[30px] md:text-[64px] tracking-[-0.04em] font-medium text-center'>
        О MITM
      </h2>
      <p className='text-center text-[14px] md:text-[16px] leading-[1.1] mt-6 mx-auto max-w-[836px] 2xl:max-w-[960px]'>
        Мы активно сотрудничаем с работодателями, получаем от них обратную связь
        и оперативно адаптируем учебные программы под требования рынка труда.
        Это позволяет нашим студентам получать актуальные знания и навыки,
        которые востребованы в реальном мире.
      </p>
      <ul
        className={cn(
          'grid mt-[30px] text-primary xl:pb-[80px]',
          'gap-[10px] grid-cols-2 grid-rows-[160px_160px]',
          'md:gap-[16px] md:grid-cols-2 md:grid-rows-[204px_204px] md:mt-[24px]',
          'lg:gap[24px] lg:grid-cols-2 lg:grid-rows-[220px_220px]',
          'xl:grid-cols-4 xl:grid-rows-[300px]',
          '2xl:grid-rows-[372px] 2xl:mt-[10px]'
        )}>
        <AboutMitmSectionCard
          title='>11 лет'
          label='обучаем наших студентов и стремимся обеспечить современный подход к обучению'
          className='bg-accent'
        />
        <AboutMitmSectionCard
          title='8500'
          label='студентов обучаются прямо сейчас'
          className='xl:translate-y-[80px]'>
          <div className='absolute inset-0'>
            <Image
              alt='about mitm image'
              src='/assets/imgs/main-page/about-mitm-section1.png'
              fill
              className='object-cover object-right'
            />
            <div className='absolute inset-0 bg-gradient-to-b from-transparent to-[rgba(0,0,0,0.5)]' />
          </div>
        </AboutMitmSectionCard>
        <AboutMitmSectionCard
          title='7 лет'
          label='специализируемся на дистанционном образовании'
          className='xl:translate-y-[80px]'>
          <div className='absolute inset-0'>
            <Image
              alt='about mitm image'
              src='/assets/imgs/main-page/about-mitm-section2.jpg'
              fill
              className='object-cover object-[50%_25%]'
            />
            <div className='absolute inset-0 bg-black/30' />
          </div>
        </AboutMitmSectionCard>
        <AboutMitmSectionCard
          title='>10 000'
          label='студентов уже обучили и выпустили из вуза'
          className='bg-tertiary'
        />
      </ul>
    </section>
  )
}
